export default {
  /* Common Colors */
  light: "#fff",
  primary: "#4b35dd",
  error: "red",
  smoth: "#EFEFEF",
  stone: "#969696",
  dark: "#000",
}
